import { createModule, getModuleByDomNode } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import * as Cookies from 'js-cookie';
import * as Overlays from '@project/shared/utils/overlays/js/overlays';
import * as Track from '@project/shared/utils/tracking/js/tracking';

const classes = {
	buttonClose: 'js-m-lounge-popup__close',
	buttonOpenLink: 'js-m-lounge-popup__open-link',
	doNotAskAgainInput: 'js-donot-ask-again__input'
};

@createModule('CustomerLoungePopup')
/**
 * CustomerLoungePopup module implementation.
 *
 * @author Ellen Xia
 */
export class CustomerLoungePopup extends TerrificSpec {
	$ctx: JQuery;
	$buttonClose: JQuery;
	$buttonOpenLink: JQuery;
	$checkDoNotAskAgain: JQuery;

	start(resolve: Function) {
		this.$ctx = $(this._ctx);
		this.$buttonClose = $(`.${classes.buttonClose}`, this.$ctx);
		this.$checkDoNotAskAgain = $(`.${classes.doNotAskAgainInput}`, this.$ctx);

		this.$buttonClose.on('click', this.onCloseClick.bind(this));
		this.$checkDoNotAskAgain.on('click', this.setCookie.bind(this));

		this.initializePopup()

		resolve();
	}

	stop() { }

	_showLoungePopup() {
		$(this._ctx).addClass('state-m-lounge-popup--visible ');
		$('html').addClass('no-scrolling--without-scrollbar');
	}

	_hideLoungePopup() {
		$(this._ctx).removeClass('state-m-lounge-popup--visible ');
		$('html').removeClass('no-scrolling--without-scrollbar');
	}

	private initializePopup(): void {
		// Perform a check for the cookie to correctly handle browser-back-behavior (where the component is still on the page).
		if (this.getCookie() != null)
			return;

		Overlays.ShowOverlay(
			() => {
				this._showLoungePopup();
				this.setCookie();
			});
	}

	private onCloseClick(): void {
		Overlays.CloseOverlay(() => {
			this._hideLoungePopup();

			// Highlight the tooltip inside the header
			$('.m-navigation-meta__tooltip').fadeIn();
		});
	}

	private getCookie(): string {
		const cookieName = 'loungepopup_read';
		return Cookies.get(cookieName);
	}

	private setCookie(): void {
		const cookieName = 'loungepopup_read';
		if (this.$checkDoNotAskAgain.prop('checked') === true) {
			// Store as a persistent cookie (replaces session cookie if exists).
			Cookies.set(cookieName, '1', { 'expires': 365 });
		} else {
			// Store as a session cookie (must delete first; does not replace permanent cookie).
			Cookies.remove(cookieName);
			Cookies.set(cookieName, '1', {});
		}
	}
}
